document.addEventListener("DOMContentLoaded", function() {
  // wait for element
  function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
      if (
        document &&
        document.querySelector(selector) &&
        document.querySelectorAll(selector).length > 0
      ) {
        clearInterval(interval);
        trigger();
      }
    }, delayInterval);
    setTimeout(function () {
      clearInterval(interval);
    }, delayTimeout);
  }

  // Wait for mapboxgl
  function waitForMapboxgl(trigger) {
    var interval = setInterval(function () {
      if (typeof mapboxgl !== "undefined") {
        clearInterval(interval);
        trigger();
      }
    }, 50);
    setTimeout(function () {
      clearInterval(interval);
    }, 15000);
  }

  // Live event listener
  function live(selector, event, callback, context = document) {
    var addEvent = (el, type, handler) => {
      el.addEventListener(type, handler);
    };

    var liveHandler = e => {
      var el = e.target?.closest(selector);
      if (el && el !== context) {
        callback.call(el, e);
      }
    };

    addEvent(context, event, liveHandler);
  }

  // Debounce function to optimize performance
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Mutation observer with debounce
  function observeElement(selector, callback) {
    function startObserving() {
      const targetElement = document.querySelector(selector);
      if (!targetElement) return;

      const debouncedCallback = debounce(callback, 300); // Adjust debounce delay as needed

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "value") {
            debouncedCallback(targetElement.value, targetElement);
          }
        });
      });

      observer.observe(targetElement, { attributes: true, attributeFilter: ["value"] });
    }

    // Watch for the element being added dynamically
    const parentObserver = new MutationObserver(() => {
      startObserving();
    });

    parentObserver.observe(document.body, { childList: true, subtree: true });

    // Start observing immediately if the element already exists
    startObserving();
  }

  // Convert text to Morse code
  function textToMorse(input) {
    var morseCodeMap = {
      'A': '.-', 'B': '-...', 'C': '-.-.', 'D': '-..', 'E': '.', 'F': '..-.',
      'G': '--.', 'H': '....', 'I': '..', 'J': '.---', 'K': '-.-', 'L': '.-..',
      'M': '--', 'N': '-.', 'O': '---', 'P': '.--.', 'Q': '--.-', 'R': '.-.',
      'S': '...', 'T': '-', 'U': '..-', 'V': '...-', 'W': '.--', 'X': '-..-',
      'Y': '-.--', 'Z': '--..', '0': '-----', '1': '.----', '2': '..---', '3': '...--',
      '4': '....-', '5': '.....', '6': '-....', '7': '--...', '8': '---..', '9': '----.',
      ' ': '/'
    };

    var upperInput = input.toUpperCase();
    var morseCode = upperInput.split('').map(char => morseCodeMap[char] || '?').join(' ');
    return morseCode;
  }

  // Update Morse code translation field
  function updateMorseCodeField(e) {
    var morseCode = textToMorse(e.target.value);
    
    // Find the closest parent `.pplr-wrapper` that contains the input
    var parentWrapper = e.target.closest(".pplr-wrapper.pplr-type-your-wordtext");
    if (parentWrapper) {
      // Find the corresponding `.pplr-morse-code-translation` within the same parent scope
      var morseWrapper = parentWrapper.parentElement.querySelector(".pplr-wrapper.pplr-morse-code-translation");
      if (morseWrapper) {
        var targetEl = morseWrapper.querySelector("input");
        if (targetEl) {
          targetEl.value = morseCode;
          targetEl.dispatchEvent(new Event("input", { bubbles: true }));
        }
      }
    }
  }
  
  // Attach event listener to the input field
  live(".pplr-wrapper.pplr-type-your-wordtext input", "keyup", updateMorseCodeField);

  /* Coordinate font adjust with debounce */
  observeElement('.pplr-font-select.pplr-longitude input', debounce((fontName, element) => {
    console.log('>> fontName', fontName);

    var longitudeElement = element.parentElement;

    // Select all matching font options in the document
    var allFonts = document.querySelectorAll(`span.pplr-selecter-item[data-name="${fontName}"]`);

    allFonts.forEach(font => {
      // Skip fonts inside the current longitudeElement
      if (!longitudeElement.contains(font)) {
        font.click();
      }
    });

    if (longitudeElement) {
      var latitudeElement = longitudeElement.closest('.pplr-wrapper').parentElement.querySelector('.pplr-wrapper.pplr-font-select.pplr-latitude');
      var selectFont = latitudeElement.querySelector(`span.pplr-selecter-item[data-name="${fontName}"]`);
      if (selectFont) {
        selectFont.click();
      }
    }
  }, 50));

  // Map location picker
  function initLocationPicker() {
    mapboxgl.accessToken = "pk.eyJ1IjoiY3VzdG9tY3VmZiIsImEiOiJja2FrczA0cXAwbmM2MnR0ZGR1dnljdGx0In0._EkFqlWTPsGRXyxeRebiYg";
    var map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/customcuff/ck6j63f0e10w11inyc4c8za4k?optimize=true',
      center: [-74.5, 40], // Default center
      zoom: 9
    });

    // insert location picker
    waitForElement(`input[name="properties[Latitude]"]`, function() {
      var targets = document.querySelectorAll(".pplr-wrapper.pplr-text.pplr-latitude");
      var element = document.querySelector(".search-location-coordinate");

      console.log('>> targets', targets, element, element);
      
      element.removeAttribute("style");
      targets[0].insertAdjacentElement("afterbegin", element.cloneNode(true));
      targets[1].insertAdjacentElement("afterbegin", element);

      document.querySelectorAll(".search-location-coordinate").forEach(container => {
        console.log(">> container", container);
        var inputField = container.querySelector("input[class='geocoder']");

        // Initialize the geocoder
        var geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
          marker: false, // Prevent automatic marker
          placeholder: 'Search for a place..'
        });

        // Append the geocoder to the input field
        inputField.replaceWith(geocoder.onAdd(map));

        // Marker for the selected location
        var marker = new mapboxgl.Marker();

        // Handle result selection
        geocoder.on("result", (event) => {
          const { center, place_name } = event.result;
          const [lng, lat] = center;

          // Move the map to the selected location
          map.flyTo({ center: [lng, lat], zoom: 12 });

          // Update marker position
          marker.setLngLat([lng, lat]).addTo(map);

          var latInput = document.querySelectorAll(`input[name="properties[Latitude]"]`);
          var lngInput = document.querySelectorAll(`input[name="properties[Longitude]"]`);

          latInput.forEach(input => {
            input.value = lat;
            input.dispatchEvent(new Event("input", { bubbles: true }));
          })

          lngInput.forEach(input => {
            input.value = lng;
            input.dispatchEvent(new Event("input", { bubbles: true }));
          })
        });
      })
    }, 30, 900000)
  }
  waitForMapboxgl(initLocationPicker);


  /* Insert app block between product options */
  function repositionAppBlock() {
    console.log('>> block found');
    var target = document.querySelector(".product-custom-switcher-box .ProductForm__Option.productOption--finish");
    var element = document.querySelector(".product-personalizer");
    target.insertAdjacentElement("afterend", element);
  }
  waitForElement(".pplr-drop-item._pplr_text.active", repositionAppBlock, 50, 90000);
});
